'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const OpenRateTrendChart = dynamic(() => import('./OpenRateTrendChart'), { ssr: false });
const CTRByCampaignChart = dynamic(() => import('./CTRByCampaignChart'), { ssr: false });
const DeviceSplitChart = dynamic(() => import('./DeviceSplitChart'), { ssr: false });
const HourlySendChart = dynamic(() => import('./HourlySendChart'), { ssr: false });

export default function AnalyticsChartsClient() {
  return (
    <div className="space-y-6">
      {/* Row 1 */}
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
        <div className="xl:col-span-2 card p-6">
          <div className="mb-5">
            <h2 className="section-header">Open Rate Trend</h2>
            <p className="text-sm text-muted-foreground mt-0.5">Daily open rate % — July 2026</p>
          </div>
          <OpenRateTrendChart />
        </div>
        <div className="card p-6">
          <div className="mb-5">
            <h2 className="section-header">Device Split</h2>
            <p className="text-sm text-muted-foreground mt-0.5">Opens by device type</p>
          </div>
          <DeviceSplitChart />
        </div>
      </div>

      {/* Row 2 */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <div className="card p-6">
          <div className="mb-5">
            <h2 className="section-header">CTR by Campaign</h2>
            <p className="text-sm text-muted-foreground mt-0.5">Click-through rate per recent campaign</p>
          </div>
          <CTRByCampaignChart />
        </div>
        <div className="card p-6">
          <div className="mb-5">
            <h2 className="section-header">Best Send Times</h2>
            <p className="text-sm text-muted-foreground mt-0.5">Avg open rate by hour of day (UTC)</p>
          </div>
          <HourlySendChart />
        </div>
      </div>
    </div>
  );
}